import React from 'react';
// Images
import DomImage from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-in-throne.webp';
import BabyImage from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-training-baby-sissy.webp';
// Components
import SubHeaderBanner from '../general/SubHeaderBanner';
import SmallGalleryComponent from '../galleries/SmallGalleryComponent';
import CallToActionOne from '../cta/CallToActionOne';

function AboutPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-16 w-full h-full pb-12'>
      {/* Dominatrix section */}
      <section
        className='grid gap-y-12 w-full'
        aria-labelledby='mistress-services-heading'
      >
        <SubHeaderBanner message={`Mistress Maria — Domination & Control`} />

        <div className='grid w-full px-6 lg:container lg:mx-auto gap-6 lg:grid-cols-rev items-center'>
          {/* Text */}
          <section className='grid h-full gap-y-4 tracking-wide order-2 lg:order-1 font-extralight'>
            <h2 id='mistress-services-heading' className='sr-only'>
              Domination Services by Mistress Maria
            </h2>

            <p>
              Strict old-school discipline including caning, detention, OTK
              spanking (my speciality), and most roleplay situations undertaken
              with attention to fine details.
            </p>
            <p>
              I am Mistress Maria — powerful, precise, and unrelenting. Whether
              you're a devoted submissive, a nervous first-timer, or a practiced
              plaything, I take control with elegance and cruelty in equal
              measure.
            </p>

            <p>
              My sessions are shaped by discipline, humiliation, and
              transformation. I offer{' '}
              <strong>sissy training, maid protocols</strong>, and full{' '}
              <strong>feminization</strong> including wardrobe, shoes, and
              corsetry. You’ll be reshaped under my command — mentally and
              physically.
            </p>

            <p>
              For the obedient, I administer{' '}
              <strong>corporal punishment</strong> using canes, whips, and
              paddles. For the restrained, I incorporate{' '}
              <strong>bondage, Segufix play</strong>, and{' '}
              <strong>abduction scenarios</strong> tailored to your fear or
              fantasy.
            </p>

            <p>
              I also offer <strong>dining experiences, medical play</strong>{' '}
              (light to moderate), and <strong>video work</strong> with prior
              consent. <strong>Pegging and strap-on</strong> sessions are
              available, with attention to detail and intensity.
            </p>

            <p>
              Discretion is absolute. Sessions are available in Norfolk
              (NR1/NR2) and select venues. <strong>Advance notice</strong> is
              required for <strong>double domme experiences</strong>.
            </p>

            <p>
              Are you ready to be broken, rebuilt, and trained under my heel?
              Then submit properly — and inquire via WhatsApp, email, or the
              contact form below.
            </p>
          </section>

          {/* Image */}
          <section className='grid order-1 lg:order-2'>
            <img
              src={DomImage}
              alt='Mistress Maria towering in heels with a cane. Her face is out of frame.'
              loading='lazy'
              width={600}
              height={800}
              className='shadow-lg max-h-[90vh]'
            />
          </section>
        </div>
      </section>

      {/* Adult baby & sissy trainer section */}
      <section
        className='grid gap-y-12 w-full'
        aria-labelledby='baby-sissy-heading'
      >
        <SubHeaderBanner message={`Nanny M's Adult Baby Nursery`} />

        <div className='grid w-full px-6 lg:container lg:mx-auto gap-6 lg:grid-cols-rev items-center'>
          {/* Text */}
          <section className='grid h-full gap-y-4 tracking-wide order-2 lg:order-1 font-extralight lg:py-8'>
            <h2 id='baby-sissy-heading' className='sr-only'>
              About Nanny M's Adult Baby Nursery
            </h2>

            <p>
              Nanny M from the original Happy2nappy nursery in the UK,
              considered one of the leading Nannies. Regularly attends events
              across the UK and abroad.
            </p>
            <p>
              Welcome to Nanny M’s Nursery — a safe, immersive space where adult
              babies and nappy diaper lovers (ABDL) can fully surrender to their
              little selves. Whether you're seeking soft nurturing or strict
              supervision, I tailor every experience to your needs. I can be as{' '}
              <strong>strict or nurturing as required</strong>.
            </p>

            <p>
              I specialize in age regression roleplay and emotional caretaking.
              My roles are flexible — I may be your gentle{' '}
              <strong>Mommy</strong>, firm <strong>Nanny</strong>, watchful{' '}
              <strong>Aunt</strong>, or no-nonsense <strong>teacher</strong>.
              Each session is shaped by who you are and what you truly crave.
            </p>

            <p>
              From bottle feeds and naptime to discipline, humiliation, and full
              sissy transformation, my nursery is fully equipped for
              exploration. I work with ABDLs, sissies, and submissives who long
              to experience deep regression in a judgment-free space.
            </p>

            <p>
              I welcome applications via{' '}
              <strong>WhatsApp, email, or text</strong>, and offer both
              in-person and virtual sessions for selected littles.
              Communication, boundaries, and mutual trust are key — and I expect
              honest obedience from those who enter my care.
            </p>

            <p>
              If you're ready to be seen, stripped of your adult facade, and
              lovingly dominated, my nursery door is open. Come to Nanny M. Let
              go, give in, and be made into what you were always meant to be.
            </p>
          </section>

          {/* Image */}
          <section className='grid order-1 lg:order-2'>
            <img
              src={BabyImage}
              alt='Mistress Maria dressed as a nurturing adult baby nanny training a sissy'
              loading='lazy'
              width={600}
              height={800}
              className='shadow-lg max-h-[90vh]'
            />
          </section>
        </div>
      </section>

      {/* Gallery */}
      <SmallGalleryComponent />

      <CallToActionOne />
    </main>
  );
}

export default AboutPageMainContainer;
